export function error(msg) {
  throw new Error(`[ODIN] ${msg}`);
}